import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type PlatformInvoiceType = "SUBSCRIPTION_ONLY" | "USAGE_ONLY" | "COMBINED";

export type PlatformInvoiceStatus =
  | "DRAFT"
  | "ISSUED"
  | "SENT"
  | "PARTIALLY_PAID"
  | "PAID"
  | "OVERDUE"
  | "VOID";

export type InvoiceLineItemType =
  | "SUBSCRIPTION"
  | "TRANSACTION_FEE"
  | "OVERAGE"
  | "ADD_ON"
  | "CREDIT"
  | "DISCOUNT"
  | "DUTY"
  | "CUSTOMS_TAX"
  | "BROKERAGE";

export interface PlatformInvoice {
  id                  : string;
  invoiceNumber       : string;
  invoiceType         : PlatformInvoiceType;
  periodStart         : string;
  periodEnd           : string;
  issueDate           : string | null;
  dueDate             : string | null;
  paidDate            : string | null;
  status              : PlatformInvoiceStatus;
  currency            : string;
  subscriptionAmount  : string;
  transactionFeeAmount: string;
  creditApplied       : string;
  subtotalAmount      : string;
  taxAmount           : string;
  totalAmount         : string;
  amountPaid          : string;
  amountDue           : string;
}

export interface PlatformInvoiceLineItem {
  id         : string;
  invoiceId  : string;
  itemType   : InvoiceLineItemType;
  description: string;
  quantity   : number;
  unitPrice  : string;
  amount     : string;
}

export interface InvoiceListParams {
  status?  : PlatformInvoiceStatus;
  year?    : number;
  search?  : string;
  fromDate?: string;
  toDate?  : string;
  page?    : number;
  limit?   : number;
}

export interface InvoiceSummary {
  total       : number;
  nextInvoice : { date: string; amount: number } | null;
  outstanding : number;
  paidThisYear: number;
  paidCount   : number;
}

export interface InvoiceListResult {
  rows    : PlatformInvoice[];
  total   : number;
  page    : number;
  limit   : number;
  summary?: InvoiceSummary;
}

export const list = (tenantId: string, params?: InvoiceListParams) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.get(`/bil/admin/tenants/${tenantId}/invoices`, params as any);

export const get = (id: string) => httpRequest.get(`/bil/admin/invoices/${id}`);
